import { lazy } from "react";

export const AccountAsync = lazy(() => import("./Account"));
